import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useFormik } from "formik";
import TextInput from "../../common/textfield/TextInput";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import TextArea from "../../common/textfield/TextArea";
import { Tooltip } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useSelector } from "react-redux";
import moment from "moment";
import { DateSelectorWithoutFormik } from "../../common/textfield/DateSelector";
import { FormikObjectSurgeryScreening } from "./Constant";
import { createSurgeryScreening } from "../api/MedicalRequest";

const CreateSurgeryScreening = () => {
    const navigate = useNavigate();
    const user = useSelector((state) => state?.auth?.user)
    const adminOrgs = useSelector((state) => state?.auth?.user?.organizations)
    const location = useLocation();
    const [btnLoading, setBtnLoading] = useState(false);
    const {medicalHistory, patientData, practionerData } = location?.state

    const formik = useFormik({
        ...FormikObjectSurgeryScreening,
        onSubmit: async(values) => {
            values.procedureName = values.procedureName?.trim();
            values.note = values.note?.trim();
                setBtnLoading(true);
                createSurgeryScreening({ ...values, patientId: patientData?.patientId, patientName: patientData?.patientName, practitionerId: practionerData?.id, practitionerName: practionerData?.name?.[0]?.text })
                .then((res) => {
                    if (res.status === true) {
                        navigate("/app/patients-details", {state:{id: patientData?.patientId, name: patientData?.patientName}});
                        success(res.message);
                    } else {
                        failed(res.error);
                    }
                })
                .catch((res) => {
                    failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                })
                .finally(() => setBtnLoading(false));
        },
    });

    const handleDateChange = (val) => {
        const isValidDate = moment(val, 'MMM-DD-YYYY').isValid()
        if(isValidDate){
          formik.setFieldValue("performedDateTime", val.format("YYYY-MM-DD"));
        }else{
            formik.setFieldError('performedDateTime', 'Invalid date format')
        }
    }

    useEffect(() => {
      localStorage.setItem("activeTableKey", "ninth");
    }, [])

  return (
    <section className="common-listing">
      <div className="heading-wrap mb-3">
        <Tooltip title="Go back">
          <div
            style={{ marginRight: "1rem", cursor: "pointer" }}
            onClick={() => navigate(-1)}
          >
            <ArrowBack />
          </div>
        </Tooltip>
      </div>
      <div className="custom-card p-4">
        <form
          className="common-form border-fields"
          onSubmit={formik.handleSubmit}
        >
          <Row>
            <Col>
              <TextInput
                keyField={"procedureName"}
                label={"Procedure"}
                formik={formik}
                placeholder={"Procedure"}
              />
            </Col>
            <Col>
              <DateSelectorWithoutFormik
                formik={formik}
                keyField={'performedDateTime'}
                label="Date"
                value={moment(formik?.values?.performedDateTime)}
                handleChange={handleDateChange}
                maxDate={moment()}
              />
            </Col>
          </Row>
          <Row>
            <Col></Col>
            <Col></Col>
          </Row>
          <Row>
            <Col>
              <TextArea
                keyField={"note"}
                label={"Note"}
                formik={formik}
                placeholder={"Note..."}
                required={false}
              />
            </Col>
          </Row>
          <div className="btn-wrap" style={{ display: "flex" }}>
            <Button
              onClick={() => !btnLoading && navigate("/app/patients-details",{state:{id: patientData?.patientId, name: patientData?.patientName}})}
              variant="secondary"
              title="Cancel"
            >
              Cancel
            </Button>
            <Button type="submit" isLoading={btnLoading}>
              Submit
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default CreateSurgeryScreening
